// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__4X9QK","meals-appear":"AvailableMeals_meals-appear__XnFYX"};